import GoTrueAdminApi from './GoTrueAdminApi';
const AuthAdminApi = GoTrueAdminApi;
export default AuthAdminApi;
//# sourceMappingURL=AuthAdminApi.js.map